export enum ApplicationUserRole {
    COACH = 'coach',
    PHYSIOTHERAPIST = 'physiotherapist',
    TEAM_LEAD = 'team_lead',
}
